// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleFilledSvg from "@fishx/icons-svg/es/asn/CopyrightCircleFilled";
import FishxIcon from '../components/FishxIcon';

var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleFilledSvg
  }));
};

CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
export default React.forwardRef(CopyrightCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyrightCircleFilled.js
// module id = 2327
// module chunks = 0